import { Header } from "../shared/Header";
import { Main } from "../shared/Main";
import { Skeleton } from "../ui/skeleton";

export const ChangelogListSkeleton = () => {
  return (
    <>
      <Header />
      <Main>
        <div className="mb-8">
          <Skeleton className="w-43 h-9 mb-2" />
          <Skeleton className="w-96 h-6" />
        </div>
        <div className="w-full space-y-4">
          {Array.from({ length: 5 }).map((_, i) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <Skeleton key={i} className="w-full h-19.5 rounded-lg" />
          ))}
        </div>
      </Main>
    </>
  );
};

export const ChangelogSkeleton = () => {
  return (
    <>
      <Header />
      <Main>
        <div className="flex mb-8">
          <Skeleton className="w-43 h-9" />
        </div>
        <div className="w-full space-y-4">
          <div className="bg-card border rounded-lg shadow-sm p-8 md:p-12">
            <div className="text-4xl font-bold mt-0 mb-6 border-b pb-3">
              <Skeleton className="w-100 h-13" />
            </div>
            <Skeleton className="font-semibold mt-8 mb-4 w-36 h-9" />
            {Array.from({ length: 10 }).map((_, i) => (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <Skeleton key={i} className="mb-4 w-250 h-7" />
            ))}
          </div>
        </div>
      </Main>
    </>
  );
};
